<template>
  <div>
    <div class="conTit" style="margin:10px 0px 25px">
      <span></span>
      <p>{{CateGory2SelCn}} 行业GMV概况</p>
      <!-- <img
        src="../../../assets/jpg/showBtn.png"
        @click="changeindustryMsg()"
        style="width:20px;height:20px;margin-left:8px"
        alt
      /> -->
      <div  class="industryMsg" v-html="industryMsg"></div>
      <p class="conTitAb" @click="changeParent()">
        <b :class="{conTitAbAct:Flag}">年度数据</b>
        <b :class="{conTitAbAct:!Flag}">月度数据</b>
      </p>
    </div>
    <div class="industry_main">
      <div class="Subtotal" v-if="CateGory1List.length>0">
        <div class="Subtotal_total">
          <span>{{CateGory2SelCn}}</span>
          <b>￥{{CateGory1List[0].salesEn}}</b>
          <h6>
            <i
              :class="parseFloat(CateGory1List[0].growth)<0?'el-icon-bottom-right industry_footBot':'el-icon-top-right industry_footTop'"
            >{{CateGory1List[0].growth}}</i>
          </h6>
        </div>
        <div class="Subtotal_total">
          <span>{{BrandSel}}</span>
          <b>￥{{CateGory1List[0].salesJnjEn}}</b>
          <h6>
            <i
              :class="parseFloat(CateGory1List[0].growthJnj)<0?'el-icon-bottom-right industry_footBot':'el-icon-top-right industry_footTop'"
            >{{CateGory1List[0].growthJnj}}</i>
          </h6>
        </div>
      </div>
    </div>
    <p style="font-size:8px;color:#494949;margin-top:5px">
      *请选择以下任意三级品类
      <i class="el-icon-caret-bottom"></i>
    </p>

    <div class="industry_foot">
      <ul>
        <li
          :class="{industry_footAct:item.category3==CateGory3Sel}"
          v-for="(item,i) in CateGory3List"
          :key="i"
          @click="SelCateGory3(item.category3,item.category3Cn)"
        >
          <div :class="{sanjiao:item.category3==CateGory3Sel}"></div>
          <van-row style="margin-top:8px">
            <van-col span="24" style="text-align:left">
              <h4>{{item.category3Cn}}</h4>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <i
                :class="parseFloat(item.growth)<0?'el-icon-bottom-right industry_footBot':'el-icon-top-right industry_footTop'"
              >{{item.growth}}</i>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <h5>市场</h5>
            </van-col>
            <van-col span="12">
              <b>{{item.salesEn}}</b>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <i
                :class="parseFloat(item.growthJnj)<0?'el-icon-bottom-right industry_footBot':'el-icon-top-right industry_footTop'"
              >{{item.growthJnj}}</i>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <h5>{{BrandSel}}</h5>
            </van-col>
            <van-col span="12">
              <b>{{item.salesJnjEn}}</b>
            </van-col>
          </van-row>
          <div style="width:100%;height:0.5px;background:#ccc;margin-top:15px"></div>
          <van-row style="margin-top:10px">
            <van-col span="12" style="line-height:30px">
              <h3
                :class="item.rank>item.lyRank?'el-icon-bottom':item.rank<item.lyRank?'el-icon-top':'el-icon-minus'"
              >{{item.rank}}</h3>
            </van-col>
            <van-col span="12" style="line-height:30px;">
              <h3>{{item.share}}</h3>
            </van-col>
          </van-row>
          <van-row style="margin-top:-8px;">
            <van-col span="12">
              <h6>年度排名</h6>
            </van-col>
            <van-col span="12">
              <h6>年度份额</h6>
            </van-col>
          </van-row>
        </li>
      </ul>
    </div>

    <div class="conTit" style="margin:0px 0 10px">
      <span></span>
      <p>{{CateGory3SelCn}} 增长率趋势</p>
    </div>
    <div class="industy_map">
      <Industymap></Industymap>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";
import Industymap from "@/components/ButFo_Radar/public/Competitive_map";
import { mapState } from "vuex";
export default {
  data() {
    return {
      BrandSel: '',
      CateGory2Sel: '',
      CateGory3Sel: '',
      CateGory2SelCn: "",
      CateGory3SelCn: "",
      platFormSel: '',
      startTime:'',
      endTime: '',
      Flag: true,
      CateGory1List: [],
      CateGory3List: [],
      industryMsg:
        "*每月28日更新前月数据",
      industryMsgFlag: false,
    };
  },
  components: {
    Industymap,
  },
  props:['ChangeFlag','SelCat2China'],
  computed: {
    ...mapState([
      "ComMonthFrom",
      "ComMonthTo",
      "ComBrand",
      "ComCateGory2",
      "ComCateGory3",
      "PlatForm",
      "ComMyFlag",
    ]),
  },
  watch: {
    SelCat2China:{
      handler(newVal,oldVal){
        this.CateGory2SelCn=newVal
      }
    },
    ChangeFlag:{
      handler(newVal,oldVal){
        this.Flag=newVal
      }
    },
    ComMonthFrom(currVal) {
      this.startTime=currVal
      this.setOneGet();
      this.setTwoGet();
    },
    ComMonthTo(currVal) {
      this.endTime=currVal
      this.setOneGet();
      this.setTwoGet();
    },
    ComBrand(currVal) {
      this.BrandSel=currVal
      this.setOneGet();
      this.setTwoGet();
    },
    ComCateGory2(currVal) {
      this.CateGory2Sel=currVal
      this.setOneGet();
      this.setTwoGet();
    },
    PlatForm(currVal) {
      this.platFormSel=currVal
      this.setOneGet();
      this.setTwoGet();
    },
  },
  methods: {
    SelCateGory3(CateGory3, CateGory3Cn) {
      this.CateGory3Sel = CateGory3;
      this.CateGory3SelCn = CateGory3Cn;
      this.$emit("chinaName", this.CateGory3SelCn);
      this.$store.dispatch("getComCateGory3", this.CateGory3Sel);
    },
    changeindustryMsg() {
      this.industryMsgFlag = !this.industryMsgFlag;
    },
    getCateGory2() {
      this.$addr
        .post(
          "/radar/getSumCateGory2",
          qs.stringify({
            platForm: this.platFormSel,
            cateGory2: this.CateGory2Sel,
            monthFrom: this.startTime,
            monthTo: this.endTime,
            brand: this.BrandSel,
          })
        )
        .then((res) => {
          this.CateGory1List = res.data.data;
          this.CateGory2Sel = this.CateGory1List[0].category2;
          this.$store.dispatch("getComCateGory2", this.CateGory2Sel);
          this.getCateGory3();
        })
        .catch((error) => {
          this.$toast("接受数据中……");
        });
    },
    getCateGory3() {
      this.$addr
        .post(
          "/radar/getSumCateGory3",
          qs.stringify({
            platForm: this.platFormSel,
            cateGory1: "",
            cateGory2: this.CateGory2Sel,
            monthFrom: this.startTime,
            monthTo: this.endTime,
            brand: this.BrandSel,
          })
        )
        .then((res) => {
          this.CateGory3List = res.data.data;
          this.CateGory3Sel = this.CateGory3List[0].category3;
          this.CateGory3SelCn = this.CateGory3List[0].category3Cn;
          this.$emit("chinaName", this.CateGory3SelCn);
          this.$store.dispatch("getComCateGory3", this.CateGory3Sel);
        })
        .catch((error) => {
          this.$toast("接受数据中……");
        });
    },
    changeParent() {
      this.$parent.changeFlag();
      this.Flag = !this.Flag;
    },
  },
  created() {
    let _ = require("lodash");
    this.setOneGet = _.debounce(this.getCateGory2, 500);
    this.setTwoGet = _.debounce(this.getCateGory3, 500);
  },
};
</script>
<style scoped>
.Subtotal {
  margin: 10px auto;
  height: 80px;
  line-height: 80px;
  padding: 0 10px;
  background: #faf1e7;
  box-shadow: 0 5px 20px 0 rgba(175, 151, 123, 0.5);
  border-radius: 20px;
  display: flex;
  justify-content: space-around;
}
.Subtotal_total {
  display: flex;
  justify-content: space-between;
}
.Subtotal_total span {
  font-family: "SourceHanSansCN-Normal";
  font-size: 12px;
  color: #5d5d5d;
  letter-spacing: 0;
  margin-top: 2px;
}
.Subtotal_total b {
  font-family: "Arial-BoldMT";
  font-size: 20px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
  margin: 0 10px;
}
.Subtotal_total h6 {
  display: block;
  text-align: center;
}
.Subtotal_total h1 {
  font-family: "Arial-BoldMT";
  font-size: 20px;
  color: #555555;
  letter-spacing: 0;
  text-align: right;
  line-height: 20px;
}
.Subtotal_total h6 i {
  display: block;
  background: #bce3a1;
  border-radius: 10.5px;
  height: 16px;
  line-height: 16px;
  width: 60px;
  margin: 55% auto;
}
.industry_foot {
  margin-top: 10px;
  overflow: hidden;
  width: 100%;
}
.industry_foot h4 {
  font-family: "SourceHanSansCN-Normal";
  font-size: 12px;
  color: #555555;
  letter-spacing: 0;
  line-height: 12px;
}
.industry_foot h5 {
  font-family: "SourceHanSansCN-Normal";
  font-size: 12px;
  color: #5d5d5d;
  letter-spacing: 0;
  line-height: 12px;
}
.industry_foot h6 {
  font-family: "SourceHanSansCN-Normal";
  font-size: 12px;
  color: #5d5d5d;
  letter-spacing: 0;
  line-height: 12px;
}

.industry_foot b {
  font-family: "Arial-BoldMT";
  font-size: 18px;
  color: #555555;
  letter-spacing: 0;
  text-align: right;
  line-height: 18px;
}
.industry_foot ul {
  overflow-x: scroll;
  overflow-y: hidden;
  min-height: 260px;
  max-height: 260px;
  width: 100%;
  margin-bottom: 15px;
  display: flex;
}
.industry_foot ul li {
  padding: 10px 10px 15px 10px;
  height: 97%;
  min-width: 28%;
  max-width: 28%;
  margin-right: 15px;
  background: #faf1e7;
  box-shadow: 0 3px 20px 0 rgba(192, 168, 139, 0.7);
  border-radius: 20px;
}
.industry_foot ul li i {
  text-align: center;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  width: 100%;
  border-radius: 15px;
  font-family: "ArialMT";
  font-size: 10px;
  color: #555555;
  letter-spacing: 0;
}
.industry_footTop {
  background: #bce3a1;
}
.industry_footBot {
  background-color: #efc2bf;
}
.industry_footAct {
  position: relative;
  background-color: #f6e7d4 !important;
  border: 3px solid #d9b17e;
  box-shadow: 0 5px 25px 0 rgba(122, 81, 32, 0.3);
}
.sanjiao {
  z-index: 6;
  position: absolute;
  width: 35px;
  height: 20px;
  background-size: cover;
  background-image: url("../../../assets/jpg/triangle.png");
  position: absolute;
  left: 50%;
  bottom: -12%;
  transform: translate(-50%, -50%);
}
.industry_foot ul li h3 {
  font-family: "SourceHanSansCN-Bold";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
}

/deep/.van-col {
  text-align: center;
}
.industy_map {
  margin-bottom: 20px;
}
.conTit {
  margin-left: 8%;
  display: flex;
  align-items: center;
  height: 20px;
  width: 100%;
  position: relative;
}
.conTit span {
  height: 13px;
  width: 5px;
  display: inline-block;
  background: #555555;
  border-radius: 3.5px;
  margin-right: 10px;
}
.conTit p {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
.conTitAb {
  width: 130px;
  position: absolute;
  right: 23px;
  line-height: 21px;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.conTitAb b {
  font-family: "SourceHanSansCN-ExtraLight";
  font-size: 14px;
  color: #484781;
  letter-spacing: 0;
  text-align: center;
  line-height: 29px;
}
.conTitAbAct {
  font-family: "SourceHanSansCN-Bold";
  color: #494949 !important;
  border-bottom: 2px solid #494949;
}
.industryMsg {
   position: absolute;
  /* min-width: 100px; */
  min-height: 10px;
  background:rgb(245,220,194);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  font-family: "SourceHanSansCN-Medium";
  font-size: 12px;
  color: #a09d9d;
  letter-spacing: 0;
  line-height: 10px;
  padding: 8px;
  top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/ButFo_Radar/public/Competitive_Overview.vue